import { observer } from "mobx-react";
import { Card } from "primereact/card";
import React from "react";
import styled from "styled-components";
import { device } from "../../WSUtils/constants/mediaQueries";
import { withWSErrorContainer } from "../../WSUtils/withWSErrorContainer";
import {
  CVPSearchParams,
  queryStringStore,
} from "../../WSUtils/wsQueryStringStore";
import MessageContent from "./MessageContent";
import { MessageTabView } from "./MessageTabView";
import NewMessageContent from "./NewMessage/NewMessageContent";
import NewMsgBtn from "./NewMessage/NewMsgBtn";

const MessagesCard: React.FC = withWSErrorContainer(
  observer(({}) => {
    const messageId = queryStringStore.qs[CVPSearchParams.cvpmsgid];
    const showNewMessage = messageId === "new";

    return (
      <StyledCard className="cvp-message-card">
        <div className="">
          <NewMsgBtn />
        </div>
        <StyledMessagesContainer className="cvp-messages-container grid flex-nowrap grid-nogutter gap-4 lg:gap-5 xl:gap-7">
          <div className="cpv-tabView-container col-12 md:col-5 ">
            <MessageTabView />
          </div>
          <div className="cpv-msg-container col-0 md:col-7 flex-shrink-1">
            {!showNewMessage ? <MessageContent /> : <NewMessageContent />}
            {/* <MessageContent /> */}
          </div>
        </StyledMessagesContainer>
      </StyledCard>
    );
  })
);
export default MessagesCard;

export const StyledCard = styled(Card)`
  &.cvp-message-card {
    max-width: 1400px;

    &.p-card .p-card-body {
      padding: 1rem;

      @media ${device.sm} {
        padding: 2rem 3rem;
      }

      @media ${device.md} {
        padding: 1.5rem;
      }

      @media ${device.lg} {
        padding: 2rem;
      }
    }

    &.p-card .p-card-content {
      display: flex;
      flex-direction: column;
      row-gap: 4rem;
    }
  }
`;

export const StyledMessagesContainer = styled.div`
  &.cvp-messages-container {
    .cpv-msg-container {
      display: none;

      @media ${device.md} {
        display: flex;
      }
    }
  }
`;
